/* Sections olyra-adv-* : date d'article, annee du pied de page, bouton collant.
   Se relance sur shopify:section:load ; aucune dependance a la position des sections. */
(function () {
  'use strict';
  if (window.__olyraAdv) return;

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];
  var observers = [];
  var listeners = [];

  function on(target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    listeners.push([target, type, fn, opts]);
  }

  function reset() {
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
    listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
    listeners = [];
  }

  function dates() {
    var d = new Date();
    document.querySelectorAll('[data-olyra-adv-date="today"]').forEach(function (el) {
      el.textContent = MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    });
    var y = new Date(); y.setDate(y.getDate() - 1);
    document.querySelectorAll('[data-olyra-adv-date="yesterday"]').forEach(function (el) {
      el.textContent = y.getDate() + ' ' + MONTHS[y.getMonth()] + ' ' + y.getFullYear();
    });
    document.querySelectorAll('[data-olyra-adv-year]').forEach(function (el) {
      el.textContent = d.getFullYear();
    });
  }

  /* Pulse : visible une fois l'image d'ouverture depassee, cache quand le dernier bouton est a l'ecran. */
  function stickyPulse(sticky) {
    var finalCta = document.querySelector('[data-olyra-adv-final]');
    var hero = document.querySelector('[data-olyra-adv-hero]');
    var pastHero = false, finalVisible = false;
    function update() {
      var show = pastHero && !finalVisible;
      sticky.classList.toggle('olyra-adv-is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    if ('IntersectionObserver' in window && hero) {
      var a = new IntersectionObserver(function (entries) {
        var e = entries[0];
        pastHero = !e.isIntersecting && e.boundingClientRect.bottom < 0;
        update();
      });
      a.observe(hero); observers.push(a);
      if (finalCta) {
        var b = new IntersectionObserver(function (entries) {
          finalVisible = entries[0].isIntersecting;
          update();
        }, { rootMargin: '0px 0px -40px 0px' });
        b.observe(finalCta); observers.push(b);
      }
    } else {
      pastHero = true;
      update();
    }
  }

  /* Journal : visible apres trois quarts d'ecran, cache quand le dernier bouton est a l'ecran. */
  function stickyJournal(sticky) {
    var finalCta = document.querySelector('[data-olyra-adv-final]');
    var finalVisible = false, ticking = false;
    function update() {
      var show = window.scrollY > window.innerHeight * 0.75 && !finalVisible;
      sticky.classList.toggle('olyra-adv-is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    if ('IntersectionObserver' in window && finalCta) {
      var o = new IntersectionObserver(function (entries) {
        finalVisible = entries[0].isIntersecting;
        update();
      }, { rootMargin: '0px 0px -40px 0px' });
      o.observe(finalCta); observers.push(o);
    }
    on(window, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    update();
  }

  /* Report : apparait au chapitre repere, disparait pour de bon une fois le dernier bouton atteint. */
  function stickyReport(bar) {
    var anchor = document.querySelector('[data-olyra-adv-anchor]');
    var last = document.querySelector('[data-olyra-adv-final]');
    var shown = false;
    function trigger() {
      if (!anchor) return 700;
      var top = anchor.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
      return top - window.innerHeight * 0.55;
    }
    function reachedLast() {
      if (!last) return false;
      return last.getBoundingClientRect().top <= window.innerHeight - 24;
    }
    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var show = (y >= trigger()) && !reachedLast();
      if (show !== shown) { shown = show; bar.classList.toggle('olyra-adv-is-on', show); }
    }
    on(window, 'scroll', update, { passive: true });
    on(window, 'resize', update);
    on(window, 'load', update);
    update();
  }

  function init() {
    reset();
    dates();
    var sticky = document.querySelector('[data-olyra-adv-sticky]');
    if (!sticky) return;
    var mode = sticky.getAttribute('data-olyra-adv-sticky');
    if (mode === 'report') stickyReport(sticky);
    else if (mode === 'journal') stickyJournal(sticky);
    else stickyPulse(sticky);
  }

  window.__olyraAdv = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { setTimeout(init, 0); });
})();
